import { render, staticRenderFns } from "./ShipmentPickingView.vue?vue&type=template&id=0cc0d140"
import script from "./ShipmentPickingView.vue?vue&type=script&lang=js"
export * from "./ShipmentPickingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports